import React, { useMemo, Fragment, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Loading from 'components/Loading'
import Divider from '../../../Divider'
import Text from '../../../Text'

import { parseHealthIssues } from '@enlyt/helpers/parse'

import _ from 'lodash'
import localization from './localization'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import NoData from '../../../MyHealthContentArea/NoDataAvailableBar'
import { sortHealthConditions } from '@web/helpers/sortBy'
import FhirEnhancedTypes from '@web/stores/FhirEnhanced/Actions'
import Button from '@web/components/LoadMoreButton'
import SthWentWrong from 'containers/MyHealth/components/MyHealthContentArea/SthWentWrong'
import withLocalization from '@web/helpers/localizationUtils'
import LearnMoreButton from '@web/components/HealthLibraryLearnMore'
import {
  healthLibrary,
  healthLibraryLoading
} from '@web/stores/FhirEnhanced/Select'
import { parseHealthLibrary } from '@web/helpers/parseEnhanced'
import { useTranslation } from 'react-i18next'
import { HEALTH_LIBRARY_MAPPING } from '@web/helpers/sources'

const HealthConditions = ({ name, loading, data, error, t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const items = useMemo(
    () => parseHealthIssues(sortHealthConditions(data)),
    [data]
  )

  const healthArticles = useSelector(healthLibrary)
  const [healthArticleData, setHealthArticleData] = useState([])
  const [currentArticleCode, setCurrentArticleCode] = useState('')
  const healthArticlesLoading = useSelector(healthLibraryLoading)
  const { i18n } = useTranslation()
  const language = i18n.language === 'es' ? 'es' : 'en'

  useEffect(
    () => {
      if (!healthArticlesLoading?.[currentArticleCode]) {
        const healthArticleData = _.get(
          healthArticles?.[language],
          currentArticleCode,
          []
        )
        const parsedData = parseHealthLibrary(healthArticleData)
        setHealthArticleData(parsedData)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [healthArticlesLoading?.[currentArticleCode]]
  )

  const openLearnMorePopup = ({ terms }) => {
    const key = terms
    const healthArticleData = _.get(healthArticles?.[language], key, [])
    setCurrentArticleCode(key)
    if (!_.isEmpty(healthArticleData)) {
      const parsedData = parseHealthLibrary(healthArticleData)
      setHealthArticleData(parsedData)
    } else if (!healthArticlesLoading?.[key]) {
      dispatch(
        FhirEnhancedTypes.healthLibrarySearch(
          language,
          terms,
          undefined,
          HEALTH_LIBRARY_MAPPING.CONDITIONS
        )
      )
    }
  }
  const handleCloseLearnMorePopup = () => {
    setHealthArticleData([])
  }

  const dispatch = useDispatch()
  const nextUrl = _.filter(data?.link, item => item.relation === 'next')[0]?.url

  const loadMoreOnClick = () => {
    dispatch(FhirEnhancedTypes.healthConditionSearchLoadMore(nextUrl))
  }

  return (
    <>
      <div style={styles.container}>
        {loading && _.isEmpty(items) && <Loading />}
        {!_.isEmpty(items) &&
          items.map((item, index) => (
            <Fragment key={index}>
              <div style={styles.testContainer}>
                <Text
                  style={styles.textLeft}
                  bold
                  label={t('condition')}
                  text={item.title}
                />
                <Text
                  label={t('status')}
                  text={item.status}
                  style={styles.textMiddle}
                />
                <Text
                  label={t('dateIdentified')}
                  text={item.recordedDate}
                  style={styles.textRight}
                />
              </div>
              <LearnMoreButton
                data={healthArticleData}
                onClick={() => openLearnMorePopup({ terms: item?.title })}
                onClose={handleCloseLearnMorePopup}
                shouldLoading={healthArticlesLoading?.[currentArticleCode]}
                mapKey={item.title}
                buttonStyle={styles.learnMoreButton}
                language={language}
              />
              {index !== items.length - 1 && <Divider />}
            </Fragment>
          ))}
        {!loading &&
          _.isEmpty(items) &&
          (error ? <SthWentWrong /> : <NoData name={name} />)}
      </div>
      {!_.isEmpty(items) && nextUrl && (
        <Button loading={loading} onClick={loadMoreOnClick} />
      )}
    </>
  )
}

export default withLocalization(HealthConditions, localization)
